module.exports = __webpack_public_path__ + "img/85.982b68f0.svg";